export default __webpack_public_path__ + "static/media/News & Announcements.918e7e57.svg";